export const data = [
    {
        id:"1",
        Image: "./images/image-product-1.jpg",
        thumbnail: "./images/image-product-1-thumbnail.jpg",
        desc: "work",
    },

    {
        id:"2",
        Image: "./images/image-product-2.jpg",
        thumbnail: "./images/image-product-2-thumbnail.jpg",
        desc: "work",
    },

    {
        id:"3",
        Image: "./images/image-product-3.jpg",
        thumbnail: "./images/image-product-3-thumbnail.jpg",
        desc: "work",
    },
    
    {
        id:"4",
        Image: "./images/image-product-4.jpg",
        thumbnail: "./images/image-product-4-thumbnail.jpg",
        desc: "work",
    }
      
];